/** Reserved provenance. Agent input is always evidence, never wake instructions. */
export const PROJECT_EVENT_CHANNEL_SOURCE = 'sam.agent_channel';
export const PROJECT_EVENT_CHANNEL_TYPE = 'agent.channel.published';
/**
 * Reserved name prefix for SAM-managed agent-to-agent message channels. Only the
 * messaging tools publish here; generic `publish_channel_event` rejects it.
 */
export const AGENT_MESSAGE_CHANNEL_PREFIX = 'agent-dm.';
/**
 * First name after every `agent-dm.<hex>` pair channel. Only SAM creates names with that prefix
 * (generic publish and follow reject it), and they are lowercase hex, so all of them sort below
 * this name: a name-ordered catalog read that starts here skips the whole range in one request.
 */
export const DIRECT_CHANNEL_RANGE_END = `${AGENT_MESSAGE_CHANNEL_PREFIX}g`;
//# sourceMappingURL=project-event-channels.js.map